var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'preloader',
    _vm.title ? 'with-title' : '',
    _vm.inline ? 'inline' : '',
    _vm.color
  ]},[_c('svg',{staticStyle:{"transform":"rotate(0deg)"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"22.22222222222222 22.22222222222222 44.44444444444444 44.44444444444444"}},[_c('circle',{staticClass:"v-progress-circular__overlay",attrs:{"fill":"transparent","cx":"44.44444444444444","cy":"44.44444444444444","r":"20","stroke-width":"4.444444444444445","stroke-dasharray":"125.664","stroke-dashoffset":"125.66370614359172px"}})]),(_vm.title)?_c('h5',{domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }